/* eslint-disable no-alert */
import { modalContextImperative } from 'root/src/client/v2/common/contexts/modal.context'
import { CampaignReportModal } from 'root/src/client/v2/_pages/campaign-creators/components/CampaignReportModal/CampaignReportModal'
import { getDropReportToDate } from 'root/src/client/logic/dropEvent/handlers/getDropReportToDate'

export default (drop, options) => async () => {
	modalContextImperative.show(
		<CampaignReportModal
			reportOptions={{
				dropEventId: drop.id,
				to: getDropReportToDate(drop),
				from: drop.liveDate,
				...options,
			}}
		/>,
	)
}
